window.ImageCarousels = window.ImageCarousels || {};

export class ImageCarousel {
  constructor(img_gal_index) {
    this.img_gal_index = img_gal_index;
    this.slide_index = 1;

    this.modal = document.getElementById("myModal-" + img_gal_index);

    this.slides = this.modal.getElementsByClassName(
      "mySlides-" + img_gal_index
    );

    this.Buttons();
  }


  Buttons() {
    const closeButton = this.modal.querySelector(".close");
    const prevButton = this.modal.querySelector(".prev");
    const nextButton = this.modal.querySelector(".next");

    if (closeButton) {
      closeButton.addEventListener("click", () => this.closeModal());
    }

    if (prevButton) {
      prevButton.addEventListener("click", () => this.plusSlides(-1));
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => this.plusSlides(1));
    }
  }

  openModal(loop_index) {
    this.modal.style.display = "block";
    this.slide_index = loop_index;
    this.showSlides();
  }

  closeModal() {
    this.modal.style.display = "none";
  }


  plusSlides(n) {
    this.slide_index += n;
    this.showSlides();
  }

  showSlides() {
    if (this.slide_index > this.slides.length) {
      this.slide_index = 1;
    }
    if (this.slide_index < 1) {
      this.slide_index = this.slides.length;
    }

    for (let i = 0; i < this.slides.length; i++) {
      this.slides[i].style.display = "none";
    }

    this.slides[this.slide_index - 1].style.display = "block";
  }
}


window.currentImageCarousel = function (img_gal_index) {
  const carousel = new ImageCarousel(img_gal_index);
  window.ImageCarousels[img_gal_index] = carousel;
};